import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api/api"; // Import the axios instance for API calls
import CustomButton from "../components/CustomButton";
import { useUser } from "../components/UserContext";
import { useToken } from "../components/TokenProvider";
import { fetchPublicAssessmentDetails } from "../store/assessmentsSlice";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment"; // Import moment

export default function Startpage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [linkHash, setLinkHash] = useState(null);
  const [message, setMessage] = useState(null);
  const [isStarting, setIsStarting] = useState(false);
  const {
    loading: assessmentDetailsLoading,
    error: assessmentDetailsError,
    singleRecord,
  } = useSelector((state) => state.assessments);

  console.log("singleRecord", singleRecord);

  useEffect(() => {
    const checkAssessmentDetails = async () => {
      const storedLinkHash = localStorage.getItem("link_hash");

      if (!storedLinkHash || storedLinkHash === "null") {
        setMessage(
          "Please check your email for assessment link and if you don't receive any link then contact your supervisor."
        );
        return;
      }
      
      try {
        const actionResult = await dispatch(
          fetchPublicAssessmentDetails({ hash: storedLinkHash })
        );
        if (fetchPublicAssessmentDetails.fulfilled.match(actionResult)) {
          setLinkHash(storedLinkHash);
          setMessage(null);
        } else {
          localStorage.setItem("link_hash", null);
          setLinkHash(null);
          setMessage("Your link is not valid. Please try again.");
        }
      } catch (error) {
        setMessage("Error fetching assessment details. Please try again.");
      }
    };

    checkAssessmentDetails();
  }, [navigate]);

  const handleStartAssessment = async () => {
    try {
      setIsStarting(true);
      const response = await api.get(`/assessment/get_question/`, {
        params: { link_hash: linkHash }, // Pass link_hash as a query parameter
      });
      setIsStarting(false);
      if (response.status === 200) {
        const questionData = response.data.data;

        if (questionData) {
          // Pass link_hash and questionData to the Questions component
          navigate("/questions", {
            state: { link_hash: linkHash, questionData },
          });
        } else {
          setMessage(
            "All questions have been attempted or no questions found."
          );
        }
      }
    } catch (error) {
      setIsStarting(false);
      setMessage(
        error.response?.data.message ||
          "Unable to start the assessment. Please try again."
      );
    }
  };

  const { setUser } = useUser();
  const { clearToken } = useToken(); // Access the token from context

  const handleLogout = () => {
    clearToken();
    setUser({});
    navigate("/");
  };

  return (
    <div className="d-flex justify-content-center align-items-center full-height-background py-5">
      <div className="col-10 p-sm-8 col-md-8 col-lg-8 col-xl-8">
        <div className="text-end mb-3">
          <CustomButton name="Logout" onClick={handleLogout} />
        </div>
        {assessmentDetailsLoading ? (
          <div className="loader-overlay">
            <div className="loader"></div>
            <div className="loading-text">Loading, please wait...</div>
          </div>
        ) : (
          <>
            <div className="card p-4 p-md-5 p-sm-3 start-page-exam position-relative">
              {singleRecord &&
                !assessmentDetailsError &&
                singleRecord.assessment_name && (
                  <div className="main-assessment-details">
                    <h1>{singleRecord.assessment_name}</h1>
                    <p>
                      Passing Percentage: {singleRecord.passing_percentage}%
                    </p>
                    <p>Total Questions: {singleRecord.total_questions}</p>
                    <p>Description: {singleRecord.assessment_description}</p>
                  </div>
                )}
              {message ? (
                <div className="alert alert-danger">{message}</div>
              ) : (
                <>
                  <table
                    className="table table-success table-striped"
                    style={{ paddingTop: "50px" }}
                    align="center"
                  >
                    <thead>
                      <tr>
                        <th scope="col">Important Instructions :</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          1. Ensure you have a stable internet connection before
                          starting.{" "}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          2. The test is timed, and you must complete it within{" "}
                          minutes.{" "}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          3. No retakes: Once submitted, you cannot attempt the
                          test again.{" "}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          4. If the link expires, you will no longer be able to
                          access the assessment.
                        </td>
                      </tr>
                      <tr>
                        <td>
                          5. Don't refresh or close the browser during the test.
                        </td>
                      </tr>
                      <tr>
                        <td>
                          6. Questions will appear in a serial fashion and going
                          to the next question is only allowed when completed
                          the present question and moving back to the
                          previous/attempted questions is not allowed.
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <p>
                    <strong>NOTE:</strong>
                  </p>
                  <ul>
                    <li>
                      This assessment link will remain active for{" "}
                      {moment(singleRecord.link_expiry_time_hours).format(
                        "DD-MM-YYYY HH:mm"
                      )}{" "}
                      , so please considering giving the exam within that time
                      frame.
                    </li>
                    <li>
                      And also please note once the assessment starts it will
                      only remain active for{" "}
                      {singleRecord.assessment_time_minutes} minutes after which
                      the assessment will automatically gets submitted.
                    </li>
                  </ul>
                </>
              )}
              {/* Render the button only if not loading and no message */}
              {!assessmentDetailsLoading && !message && (
                <button
                  type="button"
                  disabled={isStarting}
                  className="btn btn-success m-auto start-btn"
                  onClick={handleStartAssessment}
                >
                  {isStarting ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <span className="sr-only">Starting...</span>
                    </>
                  ) : (
                    "Start Assessment"
                  )}
                </button>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
